(function (appSetup) {

	appSetup.utilsFactory = function (app) {
		var utils = {
			// from jsp script tag
			setCookie: function (cookieName, cookieValue, nDays, path) {
				var today = new Date();
				var expire = new Date();
				if (nDays == null || nDays == 0) {
					nDays = 1;
				}
				expire.setTime(today.getTime() + 3600000 * 24 * nDays);
				document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expire.toGMTString() + ((path) ? "; path=" + path : "");
			},
			deleteCookie: function (name) {
				var expiredString = name + "=" + (("/") ? "; path=" + document.domain : "") + ((document.domain) ? "; domain=" + document.domain : "") + "; expires=Thu, 01-Jan-00 00:00:01 GMT";
				document.cookie = expiredString;
			},
			initServicesInArray: function (serviceArray) {
				if (serviceArray.length == 0) return;
				serviceArray.forEach(function (service) {
					app.components.getService(service).init();
				});
			},
			checkPageAccessForRole: function (pageData, role) {
				if (pageData.access.indexOf(role.type) > -1) {
					return true;
				} else {
					return false;
				}
			},
			getFormData: function (el, isCheckboxAsArray) {
				var data = $(el).serializeArray().reduce(function (obj, item) {
					obj[item.name] = item.value;
					return obj;
				}, {});

				// if (isCheckboxAsArray) {
					$(el).find("input[type='checkbox']:checked").each(function () {
						var name = $(this).attr("name");
						var val = $(this).val();
						if (name == "saveInAddressBook")
						{
							data[name] = val;
						}
						else if (val && name != "" && name !== undefined) {
							if (data[name].constructor !== Array) data[name] = [];
							data[name].push(val);
						}
					});
				// }

				return data;
			},
			getFormCheckedValues: function (form) {
				var arrayToReturn = [];
				$(form).find("input[type='checkbox']:checked").each(function () {
					var val = $(this).val();
					if (val) {
						arrayToReturn.push(val);
					}
				});
				return arrayToReturn;
			},
			getObjectByName: function (name, fragmentObjects) {
				var el;
				for (var key in fragmentObjects) {
					if (!el && name == fragmentObjects[key].name) {
						el = fragmentObjects[key];
					}
				}
				return el;
			},
			// toCamelCase: function (string) {
			// 	string = string.replace(/-([a-z])/g, function (g) { 
			// 		return g[1].toUpperCase(); 
			// 	});
			// 	return string;
			// },
			parseQueryParams: function (query) {
				var query_string = {};
				if (query) {
					var vars = query.split("&");
					for (var i = 0; i < vars.length; i++) {
						var pair = vars[i].split("=");
						pair[0] = decodeURIComponent(pair[0]);
						pair[1] = decodeURIComponent(pair[1]);
						// If first entry with this name
						if (typeof query_string[pair[0]] === "undefined") {
							query_string[pair[0]] = pair[1];
							// If second entry with this name
						} else if (typeof query_string[pair[0]] === "string") {
							var arr = [query_string[pair[0]], pair[1]];
							query_string[pair[0]] = arr;
							// If third or later entry with this name
						} else {
							query_string[pair[0]].push(pair[1]);
						}
					}
				}
				return query_string;
			},
			findPageByPath: function (path) {
				var pages = app.pages;
				var pageToReturn = false;
				for (var key in pages) {
					if (pages[key].paths.indexOf(path) > -1) {
						pageToReturn = pages[key];
					}
				}
				return pageToReturn;
			},
			findPageByTitle: function (title) {
				var pages = app.pages;
				var pageToReturn = false;
				for (var key in pages) {
					if (pages[key].title == title) {
						pageToReturn = pages[key];
					}
				}
				return pageToReturn;
			},
			removeEmptyProps: function (obj, isRecursive) {
				Object.keys(obj).forEach(function (key) {
					if (isRecursive && typeof obj[key] === 'object') {
						utils.removeEmptyProps(obj[key]);
					} else if (obj[key] === null || obj[key] === "") {
						delete obj[key];
					}
				});
				return obj;
			}
		};
		return utils;
	};

	window.appSetup = appSetup;

})(window.appSetup || {});